import React from "react";
import classnames from "classnames";
import { daysOfWeek } from "../dist/dateUtils";
const clsPrefix = "rc-Month";


const RenderWeekHeader = ({ date }) => {
  return (
    <div className={`${clsPrefix}-weekdays`}>
      {daysOfWeek(date).map((weekday, i) =>
        <div
          key={`weekday-header-${i}`}
          className={classnames(`${clsPrefix}-weekdays-weekday`)}
        >
          {weekday.format("dd")}
        </div>
      )}
    </div>
  );
};

export default RenderWeekHeader;
